import { render, staticRenderFns } from "./TrackingWidget.vue?vue&type=template&id=d798a2e0&scoped=true"
import script from "./TrackingWidget.vue?vue&type=script&lang=js"
export * from "./TrackingWidget.vue?vue&type=script&lang=js"
import style0 from "./TrackingWidget.vue?vue&type=style&index=0&id=d798a2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d798a2e0",
  null
  
)

export default component.exports